function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var HTTP = new WeakMap();
var countObj = {};

var WishlistService = /*#__PURE__*/function () {
  WishlistService.$inject = ["$http"];

  /* @ngInject */
  function WishlistService($http) {
    _classCallCheck(this, WishlistService);

    HTTP.set(this, $http);
  }

  _createClass(WishlistService, [{
    key: "add",
    value: function add(offerId, state) {
      var _this = this;

      return HTTP.get(this).post("wishlist/wishlistadd", {
        offerId: offerId,
        rnd: Math.random()
      }).then(function (response) {
        countObj.count = response.data.Count;
        $(document).trigger("add_to_wishlist");

        _this.changeWishlistControlState(offerId, state);

        return response.data;
      });
    }
  }, {
    key: "remove",
    value: function remove(offerId, state) {
      var _this2 = this;

      return HTTP.get(this).post("wishlist/wishlistremove", {
        offerId: offerId,
        rnd: Math.random()
      }).then(function (response) {
        countObj.count = response.data.Count;

        _this2.changeWishlistControlState(offerId, state);

        return response.data;
      });
    }
  }, {
    key: "getCountObj",
    value: function getCountObj() {
      return countObj;
    }
  }, {
    key: "getStatus",
    value: function getStatus(offerId) {
      return HTTP.get(this).get("/wishlist/getstatus", {
        params: {
          offerId: offerId,
          rnd: Math.random()
        }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "addWishlistScope",
    value: function addWishlistScope(id, ctrl) {
      WishlistService.wishlistsScopeList.set(id, ctrl);
    }
  }, {
    key: "changeWishlistControlState",
    value: function changeWishlistControlState(id, state) {
      var changedWishlistControl = WishlistService.wishlistsScopeList.get(id);

      if (changedWishlistControl != null) {
        changedWishlistControl.isAdded = state;
      }
    }
  }]);

  return WishlistService;
}();

WishlistService.wishlistsScopeList = new Map();
export default WishlistService;